// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.BolusTooltip--container--CpKmz {
  opacity: 1;
  display: flex;
  flex-direction: column;
  min-width: 160px;
  margin: 2px 0;
  max-width: 250px;
}

.BolusTooltip--row--Mlc5Y {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 20px;
}

.BolusTooltip--row--Mlc5Y:last-child {
  margin-bottom: -2px;
}

.BolusTooltip--label--TuCfn {
  flex-grow: 1;
}

.BolusTooltip--value--nxXlD {
  margin-left: 20px;
}

.BolusTooltip--units--cDoSp {
  min-width: 0.7em;
  margin-left: 10px;
}

.BolusTooltip--unitsWide--xDx8w {
  min-width: 2.2em;
  margin-left: 6px;
}

.BolusTooltip--title--zKhjA {
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.BolusTooltip--types--ZPhA9 {
  text-align: left;
}

.BolusTooltip--suggested--YVlJW {
  font-weight: bold;
}

.BolusTooltip--delivered--FwG__ {
  font-weight: bold;
}

.BolusTooltip--override--XxWiU {
  color: var(--bolus--ride);
  font-weight: bold;
}

.BolusTooltip--interrupted--wv8Yd {
  color: var(--bolus--interrupted);
  font-weight: bold;
}

.BolusTooltip--normal--WWOQI {
  color: var(--gray-medium);
}

.BolusTooltip--extended--zZR0i {
  color: var(--gray-medium);
}

.BolusTooltip--programmed--J14aP {
}

.BolusTooltip--carbs--G_1u6 {
}

.BolusTooltip--bg--W0Wml {
}

.BolusTooltip--iob--NyCjO {
}

.BolusTooltip--target--D8aNB {
}

.BolusTooltip--isf--_CxMA {
}

.BolusTooltip--carbRatio--mZddZ {
}

.BolusTooltip--annotation--Wn2gj {
}

.BolusTooltip--source--JUNRz {
}

.BolusTooltip--actingType--vnsjd {
}

.BolusTooltip--divider--njHTV {
  background-color: var(--bolus);
  height: 3px;
  margin: 9px -12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/daily/bolustooltip/BolusTooltip.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAGF;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EAEE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAE3B;;AAEA;EACE,yBAAyB;AAE3B;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n@import '../../../styles/colors.css';\n\n.container {\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 160px;\n  margin: 2px 0;\n  max-width: 250px;\n}\n\n.row {\n  composes: smallSize from '../../../styles/typography.css';\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  line-height: 20px;\n}\n\n.row:last-child {\n  margin-bottom: -2px;\n}\n\n.label {\n  flex-grow: 1;\n}\n\n.value {\n  margin-left: 20px;\n}\n\n.units {\n  min-width: 0.7em;\n  margin-left: 10px;\n}\n\n.unitsWide {\n  min-width: 2.2em;\n  margin-left: 6px;\n}\n\n.title {\n  composes: smallSize from '../../../styles/typography.css';\n  text-align: right;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.types {\n  text-align: left;\n}\n\n.suggested {\n  composes: row;\n  font-weight: bold;\n}\n\n.delivered {\n  composes: row;\n  font-weight: bold;\n}\n\n.override {\n  composes: row;\n  color: var(--bolus--ride);\n  font-weight: bold;\n}\n\n.interrupted {\n  composes: row;\n  color: var(--bolus--interrupted);\n  font-weight: bold;\n}\n\n.normal {\n  color: var(--gray-medium);\n  composes: row;\n}\n\n.extended {\n  color: var(--gray-medium);\n  composes: row;\n}\n\n.programmed {\n  composes: row;\n}\n\n.carbs {\n  composes: row;\n}\n\n.bg {\n  composes: row;\n}\n\n.iob {\n  composes: row;\n}\n\n.target {\n  composes: row;\n}\n\n.isf {\n  composes: row;\n}\n\n.carbRatio {\n  composes: row;\n}\n\n.annotation {\n  composes: row;\n}\n\n.source {\n  composes: row;\n}\n\n.actingType {\n  composes: row;\n}\n\n.divider {\n  background-color: var(--bolus);\n  height: 3px;\n  margin: 9px -12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BolusTooltip--container--CpKmz`,
	"row": `BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"label": `BolusTooltip--label--TuCfn`,
	"value": `BolusTooltip--value--nxXlD`,
	"units": `BolusTooltip--units--cDoSp`,
	"unitsWide": `BolusTooltip--unitsWide--xDx8w`,
	"title": `BolusTooltip--title--zKhjA ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"types": `BolusTooltip--types--ZPhA9`,
	"suggested": `BolusTooltip--suggested--YVlJW BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"delivered": `BolusTooltip--delivered--FwG__ BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"override": `BolusTooltip--override--XxWiU BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"interrupted": `BolusTooltip--interrupted--wv8Yd BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"normal": `BolusTooltip--normal--WWOQI BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"extended": `BolusTooltip--extended--zZR0i BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"programmed": `BolusTooltip--programmed--J14aP BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"carbs": `BolusTooltip--carbs--G_1u6 BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"bg": `BolusTooltip--bg--W0Wml BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"iob": `BolusTooltip--iob--NyCjO BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"target": `BolusTooltip--target--D8aNB BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"isf": `BolusTooltip--isf--_CxMA BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"carbRatio": `BolusTooltip--carbRatio--mZddZ BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"annotation": `BolusTooltip--annotation--Wn2gj BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"source": `BolusTooltip--source--JUNRz BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"actingType": `BolusTooltip--actingType--vnsjd BolusTooltip--row--Mlc5Y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"divider": `BolusTooltip--divider--njHTV`
};
export default ___CSS_LOADER_EXPORT___;
